export default {
/**  主页  **/

  /**
   * 显示隐藏店铺详情, 显示时设置商品详情页的商品信息
   * @param {*} state
   */
  toggle_show_shop_detail (state, data) {
    // 如果传来了data, 说明是在打开商品详情页面，设置商品详情页的商品信息
    if (data) {
      state.meals.single_meal_info = data
    }
    state.meals.show_shop_detail = !state.meals.show_shop_detail
  },

  /**
   * 显示提示框与否
   * @param {*} state
   */
  show_alert (state, msg) {
    let flag = false
    // 防止多次提示相同的信息
    state.alert_msg_arr.map((item, index) => {
      if (item === msg) {
        flag = true
      }
    })
    !flag && state.alert_msg_arr.push(msg)
  },

  /**
   * 关闭提示框
   * @param {*} state
   * @param {*} index
   */
  close_alert (state, index) {
    state.alert_msg_arr.splice(index, 1)
  },

  /**
   * 清空购物车
   * @param {*} state
   */
  clear_shopping_cart_data (state) {
    state.shopping_cart_data = []
    state.remarks = []
  },

  /**
   * 更新设置购物车数据, 如果购物车里存在某个商品，更新该商品数据，如果不存在，添加该商品数据
   * @param {*} state
   * @param {*} data
   */
  set_shopping_cart_data (state, data) {
    let dataIndex = -1, index = -1
    // 遍历寻找是否已有此商家数组
    state.shopping_cart_data.map((item ,i) => {
      if (item[0].busi_id === data.busi_id) {
        index = i
      }
    })
    // 如果有此商家数组
    if (index !== -1) {
      state.shopping_cart_data[index].map((item ,i) => {
        if (item.menu_id === data.menu_id && item.menu_spec_id === data.menu_spec_id) {
          dataIndex = i
        }
      })
      // 如果该商品已在购物车里
      if (dataIndex !== -1) {
        if (data.meal_count) {
          // 如果数量不为0，更新数据
          state.shopping_cart_data[index][dataIndex].meal_count = data.meal_count
        } else {
          // 数量为0，删除该商品
          state.shopping_cart_data[index].splice(dataIndex, 1)
        }
      } else {
        state.shopping_cart_data[index].push(data)
      }
    } else {
      // 如果没有此商家数组，创建新商家数组
      state.shopping_cart_data.push([data])
    }
    // 如果某商家菜品数据为空，将此空数组删除，免出现key bug
    state.shopping_cart_data.map((item, index) => {
      if (item.length === 0) {
        // 删除空数组
        state.shopping_cart_data.splice(index, 1)
        // 删除相应备注信息
        state.remarks.splice(index, 1)
      }
    })
  },

  /**
   * 购物车里修改商品数量，如果商品数量为0时，直接从购物车里删除，不为0时修改商品数量
   * @param {*} state
   * @param {*} params
   */
  modify_shopping_cart_data (state, params) {
    if (params.mealCount === 0) {
      state.shopping_cart_data[params.arrIndex].splice(params.itemIndex, 1)
    } else {
      state.shopping_cart_data[params.arrIndex][params.itemIndex].meal_count = params.mealCount
    }
    // 如果某商家菜品数据为空，将此空数组删除，免出现key bug
    state.shopping_cart_data.map((item, index) => {
      if (item.length === 0) {
        // 删除空数组
        state.shopping_cart_data.splice(index, 1)
        // 删除相应备注信息
        state.remarks.splice(index, 1)
      }
    })
  },

  /**
   * 显示隐藏购物车
   * @param {*} state
   * @param {*} is_meal_detail
   */
  toggle_show_shopping_cart (state, is_meal_detail) {
    if (is_meal_detail) {
      state.is_show_shopping_cart = true
    } else {
      state.is_show_shopping_cart = !state.is_show_shopping_cart
    }
  },

  /**
   * 当修改备注时自动修改信息
   * @param {*} state
   * @param {*} data
   */
  set_remarks_data (state, data) {
    state.remarks[data.itemIndex] = data.remarks
  },

  /**
   * 设置商家ID, 名字
   * @param {*} state
   * @param {*} busi_id
   */
  set_busi_id (state, data) {
    state.meals.busi_id = data.busi_id
    state.meals.busi_name = data.busi_name
    state.meals.dis_id = data.dis_id
  },

  /**
   * 设置评论页面所需要的个人信息
   * @param {*} state
   * @param {*} data
   */
  set_comment_need_data (state, data) {
    state.comment_need_data = data
  },

  /**
   * 设置排单ID
   * @param {*} state
   * @param {*} select_id
   */
  set_select_id (state, select_id) {
    state.meals.select_id = select_id
  },

/**  个人信息页面  **/

  /**
   * 展示隐藏设置密码的框
   * @param {*} state
   */
  toggle_show_modify_password_view (state) {
    state.user.setting.show_modify_password_view = !state.user.setting.show_modify_password_view
  },

  /**
   * 展示我的订单页面-评论弹窗与否
   * @param {*} state
   */
  toggle_show_order_comment (state) {
    state.user.order.show_comment_view = !state.user.order.show_comment_view
  },

  /**
   * 改变评价页面的星星数量
   */
  change_active_stars (state, params) {
    // 初始化数组坑位
    state.user.order.stars[params.starIndex] = params.num
    // 具体赋值，在vue里只有通过此方式赋值view才会发生变化
    state.user.order.stars.splice(params.starIndex, 1, params.num)
  },

  /**
   * 清除存储星星数量的数组
   */
  clear_active_stars (state) {
    state.user.order.stars = []
  },

/** 登陆界面 **/

  /**
   * 登陆成功后设置用户信息
   * @param {*} state
   * @param {*} data
   */
  set_user_info (state, data) {
    state.user_info = data
    state.avatar_url = data.icon_url +  '?time=' + new Date()
  },

  /**
   * 设置用户头像
   * @param {*} avatar_url
   */
  set_avatar_url (state, icon_url) {
    state.avatar_url = icon_url + '?time=' + new Date()
  },
  /**
   * 设置菜金
  */
  set_is_feedback (state, isFeedback) {
    state.user.is_feedback = isFeedback
  },
  /**
   * 更新咖啡购物车数据
  */
  updataCoffeeShop (state, val) {
    // debugger
    state.shopping_coffee_data = val
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js